import { configureStore } from '@reduxjs/toolkit';
import { creatorListenerMiddleware } from './middlewares/creatorMiddlewares';
import { StoreKey } from '@/configs/storeKeys';
import creatorReducer from './slices/creatorSlice';
import appReducer from './slices/appSlice';

export const store = configureStore({
	reducer: {
		[StoreKey.APP]: appReducer,
		[StoreKey.CREATOR]: creatorReducer,
	},
	devTools: import.meta.env.DEV,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().prepend(creatorListenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
